import React, { useState } from 'react';
import Close from '@material-ui/icons/Close';
import Form from '../../Sections/FormSection/Form';
import FormModal from '../../Sections/FormSection/FormModal';
import FormData from '../../Sections/FormSection/FormData';
import '../../Sections/FormSection/FormSection.css';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
const useStyles = makeStyles({
  margint0: {
    marginTop: '0px',
  },
  padding0: {
    padding: '0px',
  },
  padding2: {
    padding: '8px',
  },
  marginr5: {
    marginRight: '20px',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  flexColumn: {
    flexDirection: 'column',
  },
});
function ServiceForms(props) {
  const classes = useStyles();
  const [showFormModal, setShowFormModal] = useState(false);
  const [modalData, setModalData] = useState();
  const ModalData = (data) => {
    setModalData(data);
  };
  const handleFormModal = (state) => {
    setShowFormModal(state);
  };
  return (
    <div
      className={`${props.mobileVersion ? `${classes.margint0}` : 'blogdiv'} `}
    >
      <div
        className={`d-flex withfilter ${
          props.mobileVersion ? `${classes.padding0}` : `${classes.padding2}`
        }`}
      >
        {!props.mobileVersion && (
          <>
            {' '}
            <Close
              onClick={() => {
                props.onCloseForms();
              }}
            />
            <h2 className={classes.marginr5}>Forms</h2>{' '}
          </>
        )}
      </div>
      <div
        className={`formSection ${
          props.mobileVersion ? `${classes.margint0}` : ''
        }`}
        id="formSection"
      >
        <Container fixed style={{ justifyContent: 'center' }}>
          <div
            className={`${classes.row} forms  ${
              props.mobileVersion ? `${classes.flexColumn}` : ''
            }`}
          >
            {FormData.map((form, i) => (
              <Form
                key={i}
                data={form}
                setModalData={ModalData}
                handleFormModal={handleFormModal}
              />
            ))}
          </div>
        </Container>
      </div>
      {showFormModal ? (
        <FormModal
          data={modalData}
          show={showFormModal}
          handleModal={handleFormModal}
        />
      ) : (
        ''
      )}
    </div>
  );
}

export default ServiceForms;
